// extracted by mini-css-extract-plugin
export default {"countdown":"P0-z","srOnly":"Q0-z"};